import MerchantTodeb from "../../components/organisms/merchant/MerchantTodeb"
import { AdminTemplate } from "../../components"

export const MerchantTodebPage = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: 'Tödeb Yönetimi',
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true
      }}>
      <MerchantTodeb />
    </AdminTemplate>
  )
}
